import React from 'react';
import { resolveSx, elevationShadow, ELEVATION_SHADOWS } from './style-utils.js';
import './palette.less';
import './paper.less';

export { elevationShadow, ELEVATION_SHADOWS };

export interface PaperProps extends React.HTMLAttributes<HTMLElement> {
  as?: React.ElementType;
  component?: React.ElementType;
  elevation?: number;
  variant?: 'elevation' | 'outlined';
  sx?: React.CSSProperties | Record<string, unknown>;
}

export const Paper = React.forwardRef<HTMLElement, PaperProps>(({
  as,
  component,
  elevation = 1,
  variant = 'elevation',
  sx,
  style,
  className,
  children,
  ...props
}, ref) => {
  const Element: React.ElementType = component || as || 'div';
  const resolved = resolveSx(sx);
  const resolvedStyle = {
    ...(variant === 'outlined' ? null : { boxShadow: elevationShadow(elevation) }),
    ...resolved.style,
    ...style,
  };
  const resolvedClassName = [
    'ls-paper',
    'MuiPaper-root',
    variant === 'outlined' ? 'ls-paper--outlined' : '',
    resolved.className || '',
    className || '',
  ].filter(Boolean).join(' ');

  return (
    <Element ref={ref} className={resolvedClassName} style={resolvedStyle} {...props}>
      {children}
    </Element>
  );
});

Paper.displayName = 'Paper';

export default Paper;
